function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
const Img = styled.img.withConfig({
  componentId: "sc-voqve2-0"
})(["max-width:100%;", ";"], _ref => {
  let {
    focalPoint
  } = _ref;
  return focalPoint ? `height: 100%;
         width: 100%;
         object-fit: cover;
         object-position: ${focalPoint.x} ${focalPoint.y};
      ` : "";
});
const Image = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    src,
    srcSet,
    sizes,
    alt,
    disableLazy,
    focalPoint,
    onLoad,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Img, _extends({
    ref: ref,
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    alt: alt,
    role: alt ? null : "presentation",
    focalPoint: focalPoint,
    onLoad: onLoad,
    loading: disableLazy ? "eager" : "lazy"
  }, props));
});
Image.displayName = "Image";
Image.propTypes = {
  /** The path to an image */
  src: PropTypes.string,
  /** A list of one or more strings separated by commas indicating a set of possible image sources */
  srcSet: PropTypes.string,
  /** A list of one or more strings separated by commas indicating a set of source sizes */
  sizes: PropTypes.string,
  /** Textual description of the image as a fallback if the image can't load and for accessibility */
  alt: PropTypes.string,
  /** Whether to disable the default lazy loading */
  disableLazy: PropTypes.bool,
  /** x and y coordinates that denote the focus point of the image   */
  focalPoint: PropTypes.shape({
    x: PropTypes.string.isRequired,
    y: PropTypes.string.isRequired
  }),
  /** A callback invoked when the image has finished loading. Callback function will receive an Event object whose target is the native image element. */
  onLoad: PropTypes.func
};
export default Image;